// Bilingual display labels for member roles / positions / titles / bans.
// IMPORTANT: only the *display text* changes with locale. The underlying keys
// (ban_dieu_hanh, chu_nhiem, mam_non, ...) are never modified, so every
// permission / logic check keyed on those strings keeps working unchanged.

const VI = {
  role: {
    ban_dieu_hanh: 'Ban Điều Hành',
    ban_dao_tao: 'Ban Đào Tạo',
    ban_su_kien: 'Ban Sự Kiện',
    ky_thuat: 'Kỹ Thuật',
    nhan_su: 'Nhân Sự',
    su_kien: 'Sự Kiện',
    thanh_vien: 'Thành Viên',
  },
  position: {
    mam_non: 'Mầm Non',
    tap_su: 'Leve',
    culi_cap_cao: 'Culi Cấp Cao',
    bo_lao: 'Bô Lão',
    founder: 'Founder',
  },
  title: {
    founder: 'Founder',
    chu_nhiem: 'Chủ Nhiệm',
    pho_chu_nhiem: 'Phó Chủ Nhiệm',
    truong_ban_dao_tao: 'Trưởng Ban Đào Tạo',
    pho_ban_dao_tao: 'Phó Ban Đào Tạo',
    truong_ban_su_kien: 'Trưởng Ban Sự Kiện',
    pho_ban_su_kien: 'Phó Ban Sự Kiện',
  },
  ban: {
    ban_dieu_hanh: 'Ban Điều Hành',
    ban_dao_tao: 'Ban Đào Tạo',
    ban_su_kien: 'Ban Sự Kiện',
    ky_thuat: 'Kỹ Thuật',
  },
};

const EN = {
  role: {
    ban_dieu_hanh: 'Executive Board',
    ban_dao_tao: 'Training Department',
    ban_su_kien: 'Events Department',
    ky_thuat: 'Technical',
    nhan_su: 'Human Resources',
    su_kien: 'Events',
    thanh_vien: 'Member',
  },
  position: {
    mam_non: 'Rookie',
    tap_su: 'Leve',
    culi_cap_cao: 'Senior Member',
    bo_lao: 'Veteran',
    founder: 'Founder',
  },
  title: {
    founder: 'Founder',
    chu_nhiem: 'President',
    pho_chu_nhiem: 'Vice President',
    truong_ban_dao_tao: 'Head of Training',
    pho_ban_dao_tao: 'Deputy Head of Training',
    truong_ban_su_kien: 'Head of Events',
    pho_ban_su_kien: 'Deputy Head of Events',
  },
  ban: {
    ban_dieu_hanh: 'Executive Board',
    ban_dao_tao: 'Training Department',
    ban_su_kien: 'Events Department',
    ky_thuat: 'Technical',
  },
};

export function getRoleLabels(locale) {
  return locale === 'en' ? EN : VI;
}

export { VI, EN };
